import { Injectable } from '@angular/core';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';
import { Store } from '@ngrx/store';
import { exhaustMap, filter, map, of } from 'rxjs';

import { selectCompanyName } from '@public-page/store/company';

@Injectable()
export class CustomPageTitleStrategy extends TitleStrategy {
  constructor(private translateService: TranslateService, private readonly title: Title, private store: Store) {
    super();
  }

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const title = this.buildTitle(snapshot);

    this.store
      .select(selectCompanyName)
      .pipe(
        filter((val) => val !== undefined),
        exhaustMap((companyName) => {
          if (title) {
            return this.translateService
              .get(title)
              .pipe(map((translatedTitle) => `${companyName} | ${translatedTitle}`));
          } else {
            return of(companyName);
          }
        })
      )
      .subscribe((translatedTitle) => {
        this.title.setTitle(translatedTitle as string);
      });
  }
}
